import { createSlice } from '@reduxjs/toolkit'

const GROUPS_DEF = [
  {min:0, max:0},
  {min:1, max:1},
  {min:2, max:9},
  {min:10, max:20},
  {min:21, max:10000},
  {min:0, max:10000},
]

const getMinMax = (data) => {

  let min = 10000;
  let max = 0;
  if(data.length > 0) {
    min = GROUPS_DEF[data[0]].min;
  }

  for(let i = 0, len = data.length; i < len; i++) {
    
      const item = GROUPS_DEF[data[i]];

      if(item.max > max) {
        max = item.max;
      }

      if(item.min < min) {
        min = item.min;
      }
  }

  return {min, max};
}

const initialState = {
  filterYear: 2024,
  participantCountGroup: getMinMax([0,1,2,3,4,5]),
  participantCountGroupsIndx: [0,1,2,3,4,5],
  schoolData: null,
  filterSubject: 'FIZ'
}

export const schoolsSlice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    setFilterYear: (state, action) => {

      state.filterYear = action.payload
    },
    setParticipantCountGroup: (state, action) => {

      state.participantCountGroupsIndx = action.payload;

      const {min,max} = getMinMax(action.payload);

      state.participantCountGroup.min = min;
      state.participantCountGroup.max = max;
    },
    setSchoolData: (state, action) => {

      state.schoolData = action.payload;
    },
    setFilterSubject: (state, action) => {

      state.filterSubject = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setFilterYear, setParticipantCountGroup, setSchoolData, setFilterSubject } = schoolsSlice.actions

export const selectors = {
  filterYear: (state) => state.school.filterYear,
  participantCountGroup: (state) => state.school.participantCountGroup,
  participantCountGroupsIndx: (state) => state.school.participantCountGroupsIndx,
  schoolData: (state) => state.school.schoolData,
  filterSubject: (state) => state.school.filterSubject
}

export default schoolsSlice.reducer


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/schools/slice.js